import * as actionTypes from "./actionTypes";
import {
  getHSDtlList,
  getHSDetail,
  getHSpgaDetail,
  getTHSpga,
} from "../api/htsRequests";
import { saveTotals } from "../api/setFormData";
import { deleteMerchandise } from "../api/deleteFormData";
import _ from "lodash";
import { formatHTS } from "../util";

// Saves all the Duties for a Line Item (fields pertaining to context switch at line item level)
// export function saveLineItem(lineItemIndex) {
//   return (dispatch, getState) => {
//     saveLineItemDuties(getState().DescriptionOfMerchandise, lineItemIndex)
//   }
// }

export function setHSDetail(obj, callback) {
  return (dispatch) => {
    getHSDetail({ hts: formatHTS(obj.hts), tariffTreatments: obj.tariff })
      .then((response) => {
        let hsDataDtl = _.get(response, "data.eventMessage.htsNodes", false);
        dispatch({
          type: "SET_HS_DATA_DTL",
          hsData: hsDataDtl,
          tariff: obj.tariff,
          lineItemIndex: obj.lineItemIndex,
        });
      })
      .then((response) => {
        dispatch({
          type: "UPDATE_LINE_ITEM_WISE_CALCULATION",
          index: obj.lineItemIndex,
        });
      })
      .then((res) => {
        callback();
        dispatch({
          type: "UPDATE_AND_SAVE_TOTALS",
        });
      });
  };
}

export function getHTSPGA(obj) {
  return (dispatch) => {
    getTHSpga({ hts: obj.hts }).then((response) => {
      let hsDataDtl = _.get(response, "data.eventMessage.pgas", false);
      if (hsDataDtl)
        dispatch({
          type: "UPDATE_MERCH_LINE_ITEM_PGA_OBJECT",
          pgaList: hsDataDtl,
          merchandiseId: obj.merchandiseId,
          index: obj.lineItemIndex,
        });
    });
  };
}

export function getHTSPGADetails(obj) {
  return (dispatch) => {
    getHSpgaDetail(obj).then((response) => {
      let pgaDetail = _.get(
        response,
        "data.eventMessage.pgaDetails.pgaDetails[0].elements",
        false
      );
      if (pgaDetail)
        dispatch({
          type: "UPDATE_LINE_ITEM_WITH_PGA_DETAILS",
          pgaDetailData: pgaDetail,
          index: obj.lineItemIndex,
          cbsaPgaType: obj.cbsaPgaType,
          merchandiseId: obj.merchandiseId,
        });
    });
  };
}

export function handleHTSOverRide(lineItemIndex, dutyItemIndex) {}

export function updateMerchLineItemFeild(index, field, payload) {
  return {
    type: actionTypes.UPDATE_MERCH_LINE_ITEM_FIELD,
    payload,
    field,
    index,
  };
}

export function addMerchandiseLineItem(newLineItem) {
  return {
    type: actionTypes.ADD_MERCHANDISE_LINE_ITEM,
    newLineItem,
  };
}

export function removeMerchandiseLineItem(
  merchandiseId,
  updateStatus,
  updateTotal
) {
  return (dispatch, getState) => {
    deleteMerchandise(merchandiseId)
      .then((response) => {
        updateStatus();
        dispatch({
          type: "REMOVE_MERCHANDISE_LINE_ITEM",
          merchandiseId: merchandiseId,
        });
        dispatch(updateAndSaveTotals());
        setTimeout(() => {
          updateTotal();
        }, 1000);
      })
      .catch((error) => {
        console.error(`Error from axios on FIELD set: `, error);
      });
  };
}

// Save
export function saveMerchandiseField(field) {
  return {
    type: actionTypes.SAVE_MERCHANDISE_FIELD,
    field,
  };
}

export function saveDescriptionOfMerchandiseLine(
  merchandiseIndex,
  field,
  value,
  manufacturerId,
  invoiceId,
  merchandiseId,
  formType
) {
  return {
    type: actionTypes.SAVE_MERCHANDISE_LINE_ITEM,
    field,
    value,
    index: merchandiseIndex,
    manufacturerId,
    invoiceId,
    merchandiseId,
    formType
  };
}

export function savePGAData(merchandiseIndex, field) {
  return {
    type: actionTypes.SAVE_PGA_DETAILS_LINE_ITEM,
    field,
    index: merchandiseIndex,
  };
}

export function updateAndSaveTotals() {
  return {
    type: actionTypes.UPDATE_AND_SAVE_TOTALS,
  };
}

export function calculateAllInvoiceMerchandise(invoiceId) {
  return {
    type: "UPDATE_LINE_ITEM_WISE_CALCULATION_BY_INVOICE_ID",
    invoiceId,
  };
}
export function lineItemWiseCalculation(index, invoiceId, merchandiseId) {
  return {
    type: actionTypes.UPDATE_LINE_ITEM_WISE_CALCULATION,
    index,
    invoiceId,
    merchandiseId,
  };
}

export function createPGA(lineItemIndex) {
  return {
    type: actionTypes.ADD_ADDITIONAL_PGA,
    lineItemIndex,
  };
}

export function updateMerchLineItemPgaObject(id, field, payload) {
  return {
    type: actionTypes.UPDATE_MERCH_LINE_ITEM_PGA_OBJECT,
    id,
    field,
    payload,
  };
}

// Updates HTS Data Dtl information from API, saves all DTLs to be used and specificically availableProductClaimCode to filter Trade Agreements
export function updateHSDataDtl(hsDataDtl, lineItemIndex) {
  return {
    type: "SET_HS_PGA_DTL",
    payload: hsDataDtl,
    lineItemIndex,
  };
}

export function setHSDTL(hts, lineItemIndex, onLoad) {
  return (dispatch, getState) => {
    let hsCodeRoot = formatHTS(hts);
    if (!hsCodeRoot) {
      return dispatch(updateHSDataDtl({}, lineItemIndex));
    }
    getHSDtlList([hts])
      .then((response) => {
        let hsDataDtl = _.get(response, "data.eventMessage.pgas", false);
        if (hsDataDtl) {
          // if data was returned
          dispatch(updateHSDataDtl(hsDataDtl, lineItemIndex));
        } else {
          // dispatch(updateMerchLineItemFeild(lineItemIndex, 'availableProductClaimCode', []))
          return dispatch(updateHSDataDtl({}, lineItemIndex));
        }
      })
      .catch((e) => {
        console.log("Error getting hsDataDtl", e);
        return dispatch(updateHSDataDtl({}, lineItemIndex));
      });
  };
}

export function savePGAFormData(obj) {
  return (dispatch) => {
    getHSpgaDetail(obj).then((response) => {
      let pgaDetail = _.get(
        response,
        "data.eventMessage.pgaDetails.pgaDetails[0].elements",
        false
      );
      let x = 0;
      let elem = [];
      pgaDetail.map((item) => {
        elem[x] = { elementName: item.elementName, value: obj.value };

        x++;
      });
      console.log("elem is" + pgaDetail);

      if (pgaDetail)
        dispatch({
          type: "SAVE_PGA_DETAILS_LINE_ITEM",
          merchandiseId: obj.merchandiseId,

          pgaDetailDataNew: elem,
          field: obj.value,
          cbsaPgaType: obj.cbsaPgaType,
          cbsaPgaSubProgramType: obj.cbsaPgaSubProgramType,
          level: obj.level,
        });
    });
  };
}

// export function updateSubHrdVFD(requestId) {
//   return {
//     type: actionTypes.UPDATE_TOTAL_VFD_AT_SUBHRD,
//     requestId,
//   };
// }

export function updateDomHeaderPartie(
  formType,
  invoiceId,
  merchandiseId,
  manufacturerId,
  field,
  payload
) {
  return {
    type: actionTypes.UPDATE_DOM_HEADERPARTY_ITEM,
    formType,
    invoiceId,
    merchandiseId,
    manufacturerId,
    field,
    payload,
  };
}

export function updateDomHeaderPartieAddress(
  formType,
  invoiceId,
  merchandiseId,
  manufacturerId,
  field,
  payload
) {
  return {
    type: actionTypes.UPDATE_DOM_ACTOR_ADDRESS,
    formType,
    invoiceId,
    merchandiseId,
    manufacturerId,
    field,
    payload,
  };
}

export function saveDomHeaderPartyName(
  formType,
  invoiceId,
  merchandiseId,
  manufacturerId,
  field,
  payload
) {
  return {
    type: actionTypes.SAVE_DOM_HEADER_PARTY_NAME,
    formType,
    invoiceId,
    merchandiseId,
    manufacturerId,
    field,
    payload,
  };
}

export function saveDomHeaderPartyNameApplyAll(
  formType,
  invoiceId,
  merchandiseId,
  field,
  payload,
  index
) {
  return {
    type: actionTypes.SAVE_DOM_HEADER_PARTY_NAME_APPLY_ALL,
    formType,
    invoiceId,
    merchandiseId,
    field,
    payload,
    index
  };
}

export function saveDomHeaderPartyAddress(
  formType,
  invoiceId,
  merchandiseId,
  manufacturerId
) {
  return {
    type: actionTypes.SAVE_DOM_HEADER_PARTY_ADDRESS,
    formType,
    invoiceId,
    merchandiseId,
    manufacturerId,
  };
}

export function getAndUpdateInvoiceAmount(invoiceId) {
  return {
    type: actionTypes.GET_TOTAL_INVOICE_AMT,
    invoiceId,
  };
}
